export const SEGMENT_UPDATE_INFO = '1';
export const SEGMENT_ACTION_ITEMS_LIST = '2';
export const DURATION = 300;
export const AUTO_SCROLL_WAITTING = DURATION + 100;

export const RISK_TYPES = [
  { text: 'Finance', value: 'Finance' },
  { text: 'Legal', value: 'Legal' },
  { text: 'Market Competition', value: 'Market Competition' },
  { text: 'Operation', value: 'Operation' },
  { text: 'Product', value: 'Product' },
  { text: 'Production', value: 'Production' },
  { text: 'Tech', value: 'Tech' },
];
